module.exports = __webpack_public_path__ + "static/media/marker.5ad07a44.svg";